import React, { Component, useEffect, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import "../css/createadd.css";
import { Checkbox } from "antd";
import { Radio } from "antd";
import { Row, Col, Input } from "antd";
import { Image } from "antd";
import { TbEdit } from "react-icons/tb";
import { FaEye, FaEyeSlash, FaTrashAlt } from "react-icons/fa";
import { db, storage } from "../../firestore";

import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import Loading from "../loading";
import { useSelector } from "react-redux";
import {
  collection,
  addDoc,
  getDoc,
  doc,
  getDocs,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { toast } from "react-toastify";
import Tloader from "./tloader";
const Tradercreateadd = () => {
  const [addName, setAddName] = useState("");
  const [addCategory, setAddCategory] = useState("");
  const [addPrice, setAddPrice] = useState("");
  const [status, setStatus] = useState("inProgress");
  const [quantity, setQuantity] = useState("");
  const [weight, setWeight] = useState();
  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [description, setDescription] = useState("");
  const [coverImg, setCoverImg] = useState();
  const [loading, setLoading] = useState(false);
  const [disabledPb, setDisabledPb] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [addImges, setAddImges] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isAddPriceValid, setAddPriceValid] = useState(true);
  const [isAddNameValid, setAddNameValid] = useState(true);
  const [isPlatformValid, setPlatformValid] = useState(true);
  const [isAddCategoryValid, setAddCategoryValid] = useState(true);
  const [isQuantityValid, setQuantityValid] = useState(true);
  const [isWeightValid, setWeightValid] = useState(true);
  const [isLengthValid, setLengthValid] = useState(true);
  const [isWidthValid, setWidthValid] = useState(true);
  const [isHeightValid, setHeightValid] = useState(true);
  const [isDescriptionValid, setDescriptionValid] = useState(true);
  const { user } = useSelector((state) => ({ ...state }));
  const [platforms, setPlatforms] = useState([]);
  const [platform, setPlatform] = useState("");
  const getCategories = async () => {
    const categoriesRef = collection(db, "categories");
    const data = await getDocs(categoriesRef);
    setCategories(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const getPlatforms = async () => {
    const platformsRef = collection(db, "platforms");
    const data = await getDocs(platformsRef);
    setPlatforms(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  useEffect(() => {
    getCategories();
    getPlatforms();
  }, []);

  const handleChangePlatform = (e) => {
    setPlatform(e.target.value);
    setPlatformValid(e.target.value.trim() !== "");

  };
  const handleChangeAddImges = (event) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      setDisabledPb(false);
      const updatedImages = [];
      Array.from(files).forEach((file) => {
        setLoading(true);
        const storageRef = ref(storage, file.name);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setLoading2(true);
            switch (snapshot.state) {
              case "paused":
                console.log("Upload paused");
                break;
              case "running":
                // console.log("Upload running");
                break;
              default:
                break;
            }
          },
          (error) => {
            console.log(error);
          },
          () => {
            setLoading(false);
            setLoading2(false);
            getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
              updatedImages.push({ id: file.name, img: downloadedURL });
              if (updatedImages.length === files.length) {
                setAddImges((prev) => [...prev, ...updatedImages]);
              }
            });
          }
        );
      });
    }
  };

  const handleDeleteImage = (id) => {
    // Delete image from storage
    const storageRef = ref(storage, id);
    deleteObject(storageRef)
      .then(() => {
        // Update state to remove deleted image from addImges array
        setAddImges((prev) => prev.filter((img) => img.id !== id));
      })
      .catch((error) => {
        console.log("Error deleting image:", error);
      });
  };

  const handleQuantityChange = (e) => {
    setQuantity(e.target.value);
    setQuantityValid(e.target.value.trim() !== "")
  };

  const handleWeightChange = (e) => {
    setWeight(e.target.value);
    setWeightValid(e.target.value.trim() !== "")
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
    setDescriptionValid(e.target.value.trim() !== "")
  };

  const handleLengthChange = (e) => {
    setLength(e.target.value);
    setLengthValid(e.target.value.trim() !== "")
  };

  const handleWidthChange = (e) => {
    setWidth(e.target.value);
    setWidthValid(e.target.value.trim() !== "")
  };

  const handleHeightChange = (e) => {
    setHeight(e.target.value);
    setHeightValid(e.target.value.trim() !== "")
  };
  const handleChangeAddStatus = (e) => {
    setStatus(e.target.value);
    setAddCategoryValid(e.target.value.trim() !== "")
  };

  const [checkedValues, setCheckedValues] = useState([]);

  const handleChange = (checkedValues) => {
    setCheckedValues(checkedValues);
  };
  const options = [
    { label: "بلاستيشن", value: "playstation" },
    { label: "اكس بوكس", value: "xbox" },
    { label: "الحاسب الشخصي", value: "pc" },
    { label: "نينتيندو سويتش", value: "nintendo" },
  ];
  const handleChangeAddName = (e) => {
    setAddName(e.target.value);
    setAddNameValid(e.target.value.trim() !== "");

  };
  const handleChangeAddCategories = (e) => {
    setAddCategory(e.target.value);
    setAddCategoryValid(e.target.value.trim() !== "");

  };

  const handleChangeAddPrice = (e) => {
    setAddPrice(e.target.value);
    setAddPriceValid(e.target.value.trim() !== "");
  };

  const navigate = useNavigate();
  const handleChangeCoverImg = (event) => {
    const file = event.target.files[0];
    //         console.log(file)
    // return
    const storageRef = ref(storage, file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log("upload is" + progress + "% done");
        setLoading(true);
        switch (snapshot.state) {
          case "paused":
            console.log("Upload paused");
            break;
          case "running":
            console.log("Upload running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        setLoading(false);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
          // you keep uploaded img url
          setCoverImg((prev) => ({ ...prev, img: downloadedURL }));
          // console.log(data.img)
        });
      }
    );
  }

  const TradersaddRef = collection(db, "ads");

  const [tLoading, setTloading] = useState(false);

  const handleSubmit = async () => {
    
    setTloading(true);
    const isValid =
    isAddPriceValid &&
    isAddNameValid &&
    isPlatformValid &&
    isAddCategoryValid &&
    isQuantityValid &&
    isWeightValid &&
    isLengthValid &&
    isWidthValid &&
    isHeightValid
&&addImges.length>0&&coverImg
if(!addName){
  setAddNameValid(false)
}
if(!platform){
  setPlatformValid(false)
}
if(!addCategory){
  setAddCategoryValid(false)
}
if(!addPrice){
  setAddPriceValid(false)
}
if(!weight){
  setWeightValid(false)
}
if(!height){
  setHeightValid(false)
}
if(!width){
  setWidthValid(false)
}
if(!length){
  setLengthValid(false)
}
if(!quantity){
  setQuantityValid(false)
}
if(!description){
  setDescriptionValid(false)
}
if(!coverImg){
 toast.error("please add cover image")
}
if(addImges.length<1){
  toast.error("please add at least 1 image")

}
if(!isValid){
  setTloading(false)
  toast.error("please fill the required fields")
  return
}else{
  const doc = await addDoc(TradersaddRef, {
    traderName: user.name,
    ownerId: user.id,
    ownerType: "trader",
    location: [],
    status,
    addName,
    platform,
    category: addCategory,
    price: addPrice,
    productQuantity: quantity,
    shippingInfo: {
      weight,
      length,
      width,
      height,
      quantity:null,
    },
    description,
    coverImage: coverImg.img,
    images: addImges,
    isHandDelivert: false,
    isShippingCompany: true,
    createdAt: new Date(),
  });
  setTimeout(() => {
    setTloading(false);
  }, 1500);
  toast.success("تم اضافة الاعلان  بنجاح", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
  });

  navigate("/traderview");
  
}
setLoading(false) 
  };
  return (
    <>
      {tLoading ? (
        <Tloader />
      ) : (
        <div className="container-fluid">
          <div className="row ">
            <div className="col d-flex justify-content-end">
              {" "}
              <Link
                to="/traderview"
                className="text-decoration-none text-secondary text-end me-1"
              >
                <span>
                  <span className="me-2">عودة </span>
                  <BsArrowRight className="mt-1" />
                </span>
              </Link>
            </div>
          </div>
          <div className="row paj2 mt-5 rounded">
            <div className="col">
              <div className="row ">
                <div className="col text-end pe-4 mt-2  ">
                  <span className="mt-2">اضافة العنصر </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="card bg-light pb-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-2">
                    <div className="row d-flex justify-content-center">
                      {" "}
                      {coverImg && (
                        <div className="image-container">
                          {loading ? (
                            <div style={{ height: "200px", width: "200px" }}>
                              <Loading />
                            </div>
                          ) : (
                            <img
                              src={coverImg.img}
                              alt="Uploaded Image"
                              width={200}
                              height={200}
                            />
                          )}
                        </div>
                      )}
                      {!coverImg ? (
                        <Image
                          width={200}
                          height={200}
                          src="error"
                          fallback="data:image/png;base64,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"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row mt-2">
                      <div className="  ">
                        <div
                          className=" float-end "
                          data-upload-id="myUniqueUploadId"
                        >
                          <label>
                            <div className="text-center">
                            
                              تعديل صورة الغلاف <TbEdit />
                            </div>
                            <input
                              type="file"
                              hidden='true'
                              className="custom-file-input"
                              id="myUniqueUploadId"
                              onChange={handleChangeCoverImg}
                            />
                          </label>
                        </div>
                        <div className="p-1 pe-4 float-end">
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-10">
                    <div className="row">
                      <div className="col-6">
                        <div className=" mt-2 rg">
                          <div className="row d-flex justify-content-end text-end">
                            {" "}
                            <small className="float-end">حالة الاعلان</small>
                          </div>

                          <div className=" row mt-1 d-flex justify-content-center">
                            {" "}
                            <Radio.Group
                              onChange={handleChangeAddStatus}
                              value={status}
                            >
                              <Radio
                                disabled
                                value="inactive"
                                radioStyle={{ display: "block" }}
                              >
                                <span
                                  style={{ color: "#A74A4A", fontSize: "12px" }}
                                  className="pe-2"
                                >
                                  اعلان غير نشط
                                </span>
                              </Radio>
                              <Radio
                                value="active"
                                disabled
                                radioStyle={{ display: "block" }}
                              >
                                <span
                                  style={{ color: "#4AA785", fontSize: "12px" }}
                                  className="pe-2"
                                >
                                  اعلان نشط
                                </span>
                              </Radio>
                              <Radio
                                value="inProgress"
                                radioStyle={{ display: "block" }}
                              >
                                <span
                                  style={{ color: "#828282", fontSize: "12px" }}
                                  className="text-warning pe-2"
                                >
                                  بإنتظار مراجعة المسؤول{" "}
                                </span>
                              </Radio>
                            </Radio.Group>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <small className="float-end me-1"> السعر</small>
                        <input
                          type="number"
                          placeholder="نص مؤقت"
                          value={addPrice}
                          dir="rtl"
                          onChange={handleChangeAddPrice}
                          className={`form-control p2 plushH ${!isAddPriceValid ? "invalid-input" : ""}`}

                        />
                      </div>

                      <div className="col-3">
                        <small className="float-end me-1">أسم العنصر</small>
                        <input
                          type="text"
                          dir="rtl"
                          placeholder="نص مؤقت"
                          value={addName}
                          onChange={handleChangeAddName}
                          className={`form-control p2 plushH ${!isAddNameValid ? "invalid-input" : ""}`}

                        />
                      </div>
                    </div>
                    <div className="row mt-3 d-flex justify-content-center">
                      <div className="col-4">
                        <small className="float-end me-1"> المنصات</small>
                        <select
                          placeholder="Ilo Subnet"
                          className={`form-control form-select form-select-sm p2 plushH ${!isPlatformValid ? "invalid-input" : ""}`}

                          
                          aria-label=".form-select-sm example"
                          value={platform}
                          onChange={handleChangePlatform}
                        >
                          <option value={""} selected>
                            Select....
                          </option>
                          {platforms.map((s) => {
                            return (
                              <>
                                <option value={s.name}>{s.name}</option>
                              </>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-4">
                        <small className="float-end me-1"> التصنيفات</small>
                        <select
                          placeholder="Ilo Subnet"
                          // class="form-select form-select-sm"
                          className={`form-control form-select form-select-sm p2 plushH ${!isAddCategoryValid ? "invalid-input" : ""}`}

                          aria-label=".form-select-sm example"
                          value={addCategory}
                          onChange={handleChangeAddCategories}
                        >
                          <option value={""} selected>
                            Select....
                          </option>
                          {categories.map((s) => {
                            return (
                              <>
                                <option value={s.name}>{s.name}</option>
                              </>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div>
                      <Row gutter={16} className="mt-3">
                        <Col className="col-3">
                          <label
                            htmlFor="quantity"
                            className="text-end float-end"
                          >
                            الكمية
                          </label>
                          <Input
                            id="quantity"
                            className={`form-control p2 plushH ${!isQuantityValid ? "invalid-input" : ""}`}

                            value={quantity}
                            onChange={handleQuantityChange}
                          />
                        </Col>
                        <Col className="col-3">
                          <label
                            htmlFor="weight"
                            className="text-end float-end"
                          >
                            الوزن
                          </label>
                          <Input
                            className={`form-control p2 plushH ${!isWeightValid ? "invalid-input" : ""}`}
                            id="weight"
                            value={weight}
                            onChange={handleWeightChange}
                          />
                        </Col>
                        <Col className="col-2">
                          <label
                            htmlFor="length"
                            className="text-end float-end"
                          >
                            الطول
                          </label>
                          <Input
                             className={`form-control p2 plushH ${!isHeightValid ? "invalid-input" : ""}`}

                            id="length"
                            value={length}
                            onChange={handleLengthChange}
                          />
                        </Col>
                        <Col className="col-2">
                          <label htmlFor="width" className="text-end float-end">
                            العرض
                          </label>
                          <Input
                             className={`form-control p2 plushH ${!isWidthValid ? "invalid-input" : ""}`}

                            id="width"
                            value={width}
                            onChange={handleWidthChange}
                          />
                        </Col>
                        <Col className="col-2">
                          <label
                            htmlFor="height"
                            className="text-end float-end"
                          >
                            الارتفاع
                          </label>
                          <Input
                              className={`form-control p2 plushH ${!isHeightValid ? "invalid-input" : ""}`}

                            id="height"
                            value={height}
                            onChange={handleHeightChange}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6">
                    <label className="float-end text-end ">الصور</label>

                    <div>
                      <div
                        className=" uploadimg mt-4 "
                        style={{ height: "100px" }}
                      >
                        <div
                          className="custom-file-container float-end "
                          data-upload-id="myUniqueUploadId"
                        >
                          <label>
                            <span>تحميل</span> <FaEye />
                            <input
                              type="file"
                              hidden
                              accept="image/*"
                              multiple
                              onChange={handleChangeAddImges}
                              className="custom-file-input"
                              id="myUniqueUploadId"
                            />
                          </label>
                        </div>
                        <div className="p-1 pe-4 float-end">
                          <span> أو اسحب الملف</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <label className="float-end text-end">الوصف</label>
                    <textarea
    className={`form-control  des p2 plushH ${!isDescriptionValid ? "invalid-input" : ""}`}

                      // className="form-control des"
                      id="des"
                      placeholder="نص مؤقت"
                      dir="rtl"
                      value={description}
                      onChange={handleDescriptionChange}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="row">
                {addImges.map((img) => (
                  <span
                    key={img.id}
                    className="image-preview text-center mt-2 col-3"
                  >
                    <Image
                      src={img.img}
                      alt={img.id}
                      style={{
                        height: "200px",
                        width: "200px",
                        display: "inline",
                      }}
                    />
                    <br />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteImage(img.id)}
                    >
                      <FaTrashAlt className="deleteIcon" />
                    </div>
                  </span>
                ))}
              </div>

              <div className="row mt-5 d-flex justify-content-end">
                <button
                  className="btn btn-secondary send float-end  w-25"
                  onClick={handleSubmit}
                  disabled={loading===true}
                >
      {loading?'loading...':' ارسال الى مراجعة المسؤول'}                 

                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Tradercreateadd;
